/**
 * CJ Owl membership gating — single source of truth for what a Basic (non-Premium)
 * member can and can't reach.
 *
 * The model is FREEMIUM: a Basic member can freely use most of the dashboard —
 * the Household Services Hub / Service Setup, the Document Vault (capped at 100 MB),
 * Support/Concierge and account Settings. A small set of PREMIUM_PATHS are locked
 * behind Premium membership; a Basic member sees a 🔒 lock + "Upgrade to Premium"
 * on those instead of the feature.
 */

/** Premium-only feature areas. Everything NOT listed here is usable on the Basic plan. */
export const PREMIUM_PATHS = [
  "/my-account/savings",
  "/my-account/renewals",
  "/my-account/rewards",
  "/my-account/referral",
  "/my-account/value-risk-guard",
];

/** Friendly feature names for the lock screen heading, keyed by the PREMIUM_PATHS prefix. */
const PREMIUM_FEATURE_LABELS: Record<string, string> = {
  "/my-account/savings": "Savings & Opportunities",
  "/my-account/renewals": "Renewals Tracking",
  "/my-account/rewards": "Rewards Wallet",
  "/my-account/referral": "Referral Program",
  "/my-account/value-risk-guard": "Value & Risk Guard™",
};

function matchPrefix(path: string, prefixes: string[]): string | undefined {
  const p = (path || "").replace(/\/+$/, "");
  return prefixes.find((a) => p === a || p.startsWith(a + "/"));
}

/** True if `path` is a Premium-only feature (locked for Basic members). */
export function isPremiumOnly(path: string): boolean {
  return !!matchPrefix(path, PREMIUM_PATHS);
}

/** Friendly label for the locked feature (used by the FeatureLock screen). */
export function premiumFeatureLabel(path: string): string {
  const key = matchPrefix(path, PREMIUM_PATHS);
  return (key && PREMIUM_FEATURE_LABELS[key]) || "This feature";
}
